module.exports = __webpack_public_path__ + "fcae5b2a423c94ba75e93dab51d61e10.svg";